import React from "react";
import { connect } from "react-redux";
import "../css/base.css";
import IniciativaFiltro from "./IniciativaFiltro";

import {
  Container,
  Row,
  Col,
  Button,
  ListGroup,
  ListGroupItem,
} from "react-bootstrap";

import { getIniciativas } from "../actions";

class Iniciativa extends React.Component {
  handleClick(props) {
    //console.log("Inició Click");

    const _params = {
      Token: "c3649ba4e3a81815",
      Function: "GetSispeIniciativaLista",
      Parameters: {
        identificador: "0",
        id_equipo: 11,
      },
    };
    this.props.getIniciativas(_params).then((x) => {
      //console.log("Volvió Click", this.props.iniciativas);
    });
  }

  handleClickItem(props) {
    //console.log("Click Item:", props);
  }

  renderListado() {
    const _listado = this.props.iniciativas;
    //console.log("listado", _listado);
    if (!_listado) return <div>Listado</div>;

    return (
      <ListGroup>
        {_listado.map((item) => {
          return (
            <ListGroup.Item
              key={item.id_iniciativa}
              action
              onClick={this.handleClickItem.bind(this, item)}
            >
              {item.id_iniciativa}
            </ListGroup.Item>
          );
        })}
      </ListGroup>
    );
  }

  render() {
    //console.log("render lista", this.props);
    return (
      <Container fluid="xl">
        <Row>
          <Col>
            {" "}
            <span className="titulo1">Filtros de Consulta</span>
          </Col>
          <Col></Col>
        </Row>
        <IniciativaFiltro inicio={this.props.formulario} />
        <Row>
          <Col>
            <hr />
            <span className="titulo1">Resultado</span>
          </Col>
        </Row>
        <Row>
          <Col>{this.renderListado()}</Col>
        </Row>
      </Container>
    );
  }
}

const mapStatetoProps = (state) => {
  return {
    iniciativas: state.iniciativas,
    init: state.init,
    formulario: state.formulario.filtroIniciativa,
  };
};

export default connect(mapStatetoProps, { getIniciativas })(Iniciativa);
